module.exports = __webpack_public_path__ + "img/saudiarabia.387198ed.png";